var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#067BC2",
    d: "M12.333 1.954H3.667C1.643 1.956.002 3.597 0 5.621v.666c0 .185.15.334.333.334h15.334c.184 0 .333-.15.333-.334v-.666c-.002-2.024-1.643-3.665-3.667-3.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M13.631 4.138L12.22 1.315C11.644.163 10.242-.305 9.09.272l-.063.032-6.852 3.69c-.162.087-.222.29-.135.451.058.108.171.175.293.175h11c.184 0 .334-.15.334-.333 0-.052-.012-.103-.036-.15v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M2.333 3.954h11.334C14.955 3.954 16 5 16 6.287v6.667c0 1.289-1.045 2.333-2.333 2.333H2.333C1.045 15.287 0 14.243 0 12.954V6.287C0 5 1.045 3.954 2.333 3.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M15.667 7.287H13c-1.289.001-2.333 1.046-2.332 2.335 0 1.288 1.044 2.331 2.332 2.332h2.667c.184 0 .333-.15.333-.333v-4c0-.184-.15-.334-.333-.334z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 9.621,
    r: 1,
    fill: "#579FD7"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.47f492dd.svg";
export { ForwardRef as ReactComponent };